import { RouteConfig } from 'vue-router';

const PAGE_TITLE = '上游·天才足球青训营';

const route: RouteConfig = {
  path: '/2019FootballBootCamp',
  name: 'ShangyouFootballBootCamp',
  component: () => import('./RoutesHolder.vue'),
  redirect: '/2019FootballBootCamp/Home',
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'Home',
      name: 'FootballBootCampHome',
      component: () => import('./Home.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'Register',
      name: 'FootballBootCampRegister',
      component: () => import('./Register.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'Info',
      name: 'FootballBootCampInfo',
      component: () => import('./Info.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
  ],
};

export default route;
